import ImageZoom from "../../commons/ImageZoom";

const JavaCoffee = () => {
  return (
    <div className="portfolio">
      <header className="portfolio-header">
        <p className="portfolio-kicker">Jeu &amp; campagne marque</p>
        <h1>Java Coffee</h1>
        <p>
          Un jeu 2D accessible via codes uniques dans les sachets de café — pour
          engager les clients autour de la marque Java.
        </p>
      </header>

      <section className="portfolio-section">
        <h2>Fonctionnalités</h2>
        <div className="portfolio-projects">
          <div className="project">
            <ImageZoom alt="Écran de connexion avec code unique" src="./assets/java-login.jpg" />
            <h3>Code à usage unique</h3>
            <p>
              Durant 8 mois, 16&nbsp;000 codes placés dans des sachets de café
              ouvraient une participation au jeu et une chance de remporter un
              prix.
            </p>
          </div>
          <div className="project">
            <ImageZoom alt="Gameplay du jeu Java Coffee" src="./assets/java-game.jpg" />
            <h3>Règles du jeu</h3>
            <p>
              Après un tutoriel, les joueurs ramassent les graines saines pour
              remplir la barre à 100&nbsp;%, puis capturent 3 grains dorés pour
              devenir éligibles au tirage.
            </p>
          </div>
          <div className="project">
            <ImageZoom alt="Écran de victoire" src="./assets/java-win.jpg" />
            <h3>Cadeaux</h3>
            <p>
              Parmi les lots : 2 machines à café, 15 paquets de café et des bons
              de réduction répartis sur toute la campagne.
            </p>
          </div>
        </div>
      </section>

      <section className="portfolio-section">
        <h2>À propos du projet</h2>
        <p>
          Dans le cadre d’une campagne ludique pour la marque Java, j’ai conçu un
          jeu 2D accessible grâce à des codes uniques trouvés dans des sachets
          spécialement marqués. Une fois le code saisi, les participants
          contrôlaient un sac de café à la souris.
        </p>
        <p>
          L’objectif : récupérer 10 graines en évitant les obstacles, puis
          attraper 3 grains dorés — clé de l’éligibilité au concours. L’expérience
          alliait simplicité et divertissement, tout en renforçant l’attachement
          à la marque.
        </p>
        <img
          src="./assets/java-logo.jpg"
          alt="Logo Java Coffee"
          className="about-image"
        />
      </section>

      <footer className="portfolio-footer">
        <a href="mailto:julien.j.1999@hotmail.com">
          Contactez-moi : julien.j.1999@hotmail.com
        </a>
      </footer>
    </div>
  );
};

export default JavaCoffee;
